import {Next} from "./actions/nextState.action";
import {SetPartner} from "./actions/setPartner.action";
import {SetGoal} from "./actions/setGoal.action";
import {SetService} from "./actions/setService.actions";
import {SetPackageTemplate} from "./actions/setPackageTemplate.action";
import { Address, BasisType, Customer, Goal, Partner, Service, PackageTemplate, Package } from "@raskrask-dk/raskrask-utils";
export type PackageAction = SetPartner | Next | SetGoal | SetService | SetPackageTemplate;

export const packageActions = [SetPartner, Next, SetGoal, SetService, SetPackageTemplate] as const;

export type packActions = typeof packageActions[number];

/**
 * ISSUE (Github.com is down):
 *  - Should this be a number or an enum?
 *  - If enumb, should this come from the API?
 */
export type Multiplier = number;

export interface PackageStateDependencies {
  address: Address;
  basisType: BasisType;
  customerType: Customer["type"];
  goal?: Goal;
  partner?: Partner;
  service?: Service;
  packageTemplate?: PackageTemplate;
}

export interface IGetPackageStateData {
  package: Package | undefined;
  basisType: BasisType;
  address: Address;
  customerType: Customer["type"];
  goal: Goal | undefined;
  service: Service | undefined;
  partner: Partner | undefined;
  packageTemplate: PackageTemplate | undefined;
}
